import React from "react";
import { Route, Routes } from "react-router-dom";
import GLNView from "../gln/src/view/GLNView";

function Routing() {
  return (
    <>
      <Routes>

        <Route
          path="/"
          element={< GLNView />}
        />
      </Routes>
    </>
  );
}

export default Routing;
